import React from "react";
import ok from "../assets/images/svg/ok.svg";
import pratiqueVatel from "../assets/images/vatel/pratique.png";
import { useSmoothScrollContext } from "../context/SmoothScrollContext";

const ContentLeftOne = () => {
  const { handleLinkClick } = useSmoothScrollContext();
  return (
    <div id="pedagogie" className="bg-[url('../images/all-img/section-bg-2.png')] bg-cover bg-no-repeat bg-center section-padding">
      <div className="container">
        <div className="lg:grid grid-cols-12 gap-[30px]">
          <div className="xl:col-span-5 lg:col-span-6 col-span-12">
            <div className="mini-title">Une pédagogie unique pour réussir</div>
            <h4 className="column-title tw-leading-tight">
              <span className="shape-bg">50%</span> de la pédagogie dédiée à l'expérimentation en conditions réelles.
            </h4>
            <div>
              C'est en observant, en agissant, en se trompant aussi, que l'on comprend mieux les métiers et leurs interactions. Alors, les trois premières années :
            </div>
            <ul className=" space-y-2 pt-8">
              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt="" />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className=" text-lg mb-1 font-semibold">
                    Vous alternez semaines d'enseignement théorique et semaines d'expérimentation dans les hôtels, restaurants et/ou cafés Vatel.
                  </h4>
                </div>
              </li>
              <li className="flex flex-wrap">
                <div className="flex-none mr-3">
                  <div className="">
                    <img src={ok} alt="" />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className=" text-lg mb-1 font-semibold">
                    Vous vous exercez aux métiers de ceux que vous managerez plus tard et vous apprenez au contact de vrais clients.
                  </h4>
                </div>
              </li>
            </ul>
            <div className="pt-8">
              <a
                  id="btn-brochure-pedagogie"
                  href="#brochure"
                  onClick={(e) => handleLinkClick(e, 'brochure')}
                  className="btn btn-primary w-full lg:w-auto inline-block text-center"
              >
                Demandez votre brochure
              </a>
            </div>
          </div>
          <div className="xl:col-span-7 lg:col-span-6 col-span-12 lg:pt-0 md:pt-10 pt-6">
            <img src={pratiqueVatel} alt="Une pédagogie unique pour réussir - Vatel" className=" mx-auto block w-full"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentLeftOne;
